module.exports = __webpack_public_path__ + "media/images/home/docenti01-3bf023a288cb6af00bf2ccaba7810872.svg";